import * as api from "../utils/api"
import { getAndFormatOrderTracks, formatOrderTracksV2 } from "../actions/orderTrack"
import { SOURCE_TYPE, EVENT_SHELF_CHANGE, EVENT_PERSON_ENTRY } from "../Config"

export const loadCameraFrameData = async (
  storeId,
  cameraId,
  startTimestamp,
  endTimestamp,
  onCameraFrameData,
  taskVersion,
  taskTrackId,
  taskOrderId,
  isPrefetchVideo = false
) => {
  let rawTrackList = {}
  let formattedOrderTracks = {}
  let orders = {}
  let eventsList = []
  let trackStartData = {}
  console.log("V2 taskVersion = " + taskVersion)
  console.log("V2 taskOrderId = " + taskOrderId)

  if (taskVersion && Number(taskVersion) === 2) {
    let result = await loadRawAndOrderTracks(cameraId, startTimestamp, endTimestamp, taskOrderId)
    const rawTracksResult = result.rawTracks
    const ordersResult = result.orderTracks
    const trackStartResult = result.trackStart
    console.log("V2 trackStart = " + JSON.stringify(trackStartResult))
    const rawTracksFormattedList = formatRawTracks(rawTracksResult, cameraId)
    const formattedOrderData = formatOrderTracksV2(cameraId, rawTracksResult, ordersResult)
    formattedOrderTracks = formattedOrderData.formattedOrderTracks
    orders = formattedOrderData.orders
    rawTrackList = rawTracksFormattedList
    if (trackStartResult) {
      trackStartData = JSON.parse(trackStartResult)
    }
    let lstEvent
    // = await loadEvents(startTimestamp, endTimestamp)
    if (lstEvent) {
      eventsList = lstEvent.eventsList
    }
    onCameraFrameData(
      cameraId,
      rawTracksFormattedList,
      formattedOrderTracks,
      orders,
      eventsList,
      trackStartData?.ts,
      trackStartData?.cam_id,
      isPrefetchVideo
    )
  } else {
    loadRawTracks(storeId, cameraId, startTimestamp, endTimestamp)
      .then((lstRawTrack) => {
        rawTrackList = lstRawTrack
        return getAndFormatOrderTracks(storeId, cameraId, startTimestamp, endTimestamp)
      })
      .then((lstOrderTrack) => {
        if (lstOrderTrack) {
          formattedOrderTracks = lstOrderTrack.formattedOrderTracks
          orders = lstOrderTrack.orders
        }
        /*   return loadEvents(startTimestamp, endTimestamp)
      })
      .then((lstEvent) => {
        if (lstEvent) {
          eventsList = lstEvent.eventsList
        }*/
        console.log(
          "Calling onCameraFrameData with formattedOrderTracks:" +
            JSON.stringify(formattedOrderTracks) +
            " orders = " +
            JSON.stringify(orders)
        )
        onCameraFrameData(
          cameraId,
          rawTrackList,
          formattedOrderTracks,
          orders,
          eventsList,
          undefined,
          undefined,
          isPrefetchVideo
        )
      })
  }
}

export const loadFrameRawTrackData = async (
  storeId,
  cameraId,
  startTimestamp,
  endTimestamp,
  taskOrderId,
  taskVersion,
  callbackFn
) => {
  const rawTracks = await getFrameRawTrackData(
    storeId,
    cameraId,
    startTimestamp,
    endTimestamp,
    taskOrderId,
    taskVersion
  )
  callbackFn(rawTracks)
}

const getFrameRawTrackData = async (
  storeId,
  cameraId,
  startTimestamp,
  endTimestamp,
  taskOrderId,
  taskVersion
) => {
  let rawTracks = {}
  if (taskVersion && Number(taskVersion) === 2) {
    const result = await loadRawAndOrderTracks(cameraId, startTimestamp, endTimestamp, taskOrderId)
    const rawTracksResult = result.rawTracks
    rawTracks = formatRawTracks(rawTracksResult, cameraId)
  } else {
    rawTracks = await loadRawTracks(storeId, cameraId, startTimestamp, endTimestamp)
  }
  return rawTracks
}

async function loadRawAndOrderTracks(cameraId, startTimestamp, endTimestamp, taskTrackId) {
  console.log("V2 inside loadRawAndOrderTracks taskTrackId = " + taskTrackId)
  let result = await api.getRawAndOrderTracks(cameraId, startTimestamp, endTimestamp, taskTrackId)
  return result
}

function loadRawTracks(storeId, cameraId, startTimestamp, endTimestamp) {
  return api.getRawTrack(storeId, cameraId, startTimestamp, endTimestamp).then((rawTracks) => {
    if (rawTracks && "data" in rawTracks) {
      rawTracks = rawTracks["data"]
    }
    return formatRawTracks(rawTracks, cameraId)
  })
}

function formatRawTracks(rawTracks, cameraId) {
  let rawTrackList = {}
  if (rawTracks) {
    for (const [epochTimestamp, tracks] of Object.entries(rawTracks)) {
      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i]
        const rawTrackId = track["rawtrack_id"]
        const x = track["tlx"]
        const y = track["tly"]
        const width = track["brx"] - x
        const height = track["bry"] - y
        const keyPoints = track["keypoints"]
        if (!rawTrackList[epochTimestamp]) {
          rawTrackList[epochTimestamp] = {}
        }
        if (!rawTrackList[epochTimestamp][cameraId]) {
          rawTrackList[epochTimestamp][cameraId] = []
        }
        rawTrackList[epochTimestamp][cameraId].push({
          rawTrackId,
          x,
          y,
          width,
          height,
          keyPoints,
        })
      }
    }
  }
  return rawTrackList
}

export const getEventDetails = (event) => {
  let eventType = event["type"]
  let eventEnd = event["end"] ? event["end"] : "on-going"
  let eventDetails = event["start"] + " - " + eventEnd + "; " + eventType + "; "
  eventDetails += event["state"] + "; " + event["source"]
  if (eventType === EVENT_SHELF_CHANGE) {
    eventDetails += event["wt_change"] > 0 ? "; Put " : "; Picked "

    eventDetails += Math.abs(event["wt_change"])
    eventDetails += "gms [" + event["wt_change_min"] + ", " + event["wt_change_max"] + "]"
  } else if (eventType === EVENT_PERSON_ENTRY) {
    eventDetails += "; Customer Id " + event["person"]
  }
  return eventDetails
}

/*async function loadEvents(startTimestamp, endTimestamp) {
  let eventsList = []
  let offset = 0
  let numberOfEventsRetrieved = 0
  do {
    let eventResult = await api.getEventsByTime(startTimestamp, endTimestamp, offset)
    numberOfEventsRetrieved = 0
    if (eventResult && Object.keys(eventResult).length > 0) {
      const events = eventResult["events"]
      if (events) {
        const eventIds = Object.keys(events)
        numberOfEventsRetrieved = eventIds.length
        eventsList = eventsList.concat(
          eventIds.map((eventId) => {
            let event = events[eventId]
            delete event["event_id"]
            return { ...event, eventId, id: eventId }
          })
        )
      }
    }
    offset = offset + 100
  } while (numberOfEventsRetrieved >= 100)
  return { eventsList }
} */

export const loadEventDetails = (eventList) => {
  let eventsList = []
  if (eventList) {
    let eventPromises = []
    eventList.forEach((eventId) => {
      let eventPromise = api.getEvent(eventId)
      eventPromises.push(eventPromise)
    })

    return Promise.all(eventPromises).then((events) => {
      if (events && events.length > 0) {
        events.forEach((event) => {
          if (event) {
            eventsList.push({ ...event, eventId: event.id })
          }
        })
      }
      return { eventsList: eventsList }
    })
  }
}

const findShelfCamOfType = (shelf, cameraList, camTypeToFind) => {
  let cameraId = null
  for (let key in shelf) {
    // eslint-disable-line no-unused-vars
    if (key.startsWith("cam::")) {
      let currKeySuffix = key.replace("cam::", "")
      // if cam is tracking, set as cameraId and return shelf values
      for (let i = 0; i < cameraList.length; i++) {
        let camera = cameraList[i]
        if (camera.type === camTypeToFind && currKeySuffix === camera.serial) {
          cameraId = camera.serial
          break
        }
      }
      if (cameraId != null) {
        break
      }
    }
  }
  return cameraId
}

export const getSource = async (storeId, sourceId, sourceType) => {
  let source = await api.getSource(sourceId, sourceType)
  if (!storeId) {
    return { cameraId: null, source: source }
  }
  return api.getCameras(storeId).then((camListResp) => {
    console.log("getCameras API response: ", camListResp)

    let cameraId = null

    if (camListResp && Array.isArray(camListResp) && camListResp.length > 0) {
      const cameraList = camListResp.map((camera) => {
        return { serial: camera.deviceId, type: camera.cameraSubType }
      })
      console.log(`cameraList::${JSON.stringify(cameraList)}`)
      cameraId = findShelfCamOfType(source, cameraList, "tracking")
      if (sourceType === SOURCE_TYPE.SHELF && cameraId == null) {
        cameraId = findShelfCamOfType(source, cameraList, "product")
      }
    }

    if (cameraId == null) {
      for (let key in source) {
        // eslint-disable-line no-unused-vars
        if (key.startsWith("cam::")) {
          cameraId = key.replace("cam::", "")
          break
        }
      }
    }
    return { cameraId, source }
  })
}
